import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {BaseService} from "../base/base.service";
import {ArquivoMetadados} from "../../core/arquivo-metadado";
import {Rotas} from "../../core/rotas";

@Injectable({
    providedIn: "root",
})
export class ArquivoConteudoRimService extends BaseService<ArquivoMetadados> {
    constructor(http: HttpClient) {
        super(http, Rotas.CONTEUDO_RIM_ARQUIVO);
    }

    gravar(file: File, idConteudoRim: number) {
        const formData = new FormData();
        formData.append('file', file);
        return this.http.post(Rotas.CONTEUDO_RIM_ARQUIVO + idConteudoRim, formData);
    }

    get(idConteudoRim: number) {
        return this.http.get(Rotas.CONTEUDO_RIM_ARQUIVO + idConteudoRim, {responseType: 'arraybuffer'});
    }

}